export const SEARCH_FRIEND_TO_PICKUP_KIDS = 'SEARCH_FRIEND_TO_PICKUP_KIDS';
export const SEARCH_FRIEND_TO_SELL_TICKET = 'SEARCH_FRIEND_TO_SELL_TICKET';